module.exports = __webpack_public_path__ + "static/img/1_0043.2e224df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0043.jpg
// module id = Jc4C
// module chunks = 0